import React from "react";
import "../../styles/login.css";
import LoginLogo from "../../forms/Auth/LoginLogo";
import LoginForm from "../../forms/Auth/LoginForm";

const LoginView = () => {
  return (
    <div className="login-container">
      <div className="login-logo-container">
        <LoginLogo/>
      </div>
     <div className="login-form">
        <LoginForm/>
      </div>
      
    </div>
  );
};

export default LoginView;
